import { render, staticRenderFns } from "./Fundamental.vue?vue&type=template&id=6463b05a&scoped=true&"
import script from "./Fundamental.vue?vue&type=script&lang=js&"
export * from "./Fundamental.vue?vue&type=script&lang=js&"
import style0 from "./Fundamental.vue?vue&type=style&index=0&id=6463b05a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6463b05a",
  null
  
)

export default component.exports